function identity<T>(x: T): T {
  return x;
}

export default identity;